export class ActionType {
  static Replace = 'REPLACE';
  static Increment = 'INCREMENT';
  static Decrement = 'DECREMENT';
  static Append = 'APPEND';
  static Prepend = 'PREPEND';
}
